import ComptesListView from "@/pages/super-admin/components/ComptesListView";

export default function SuperAdminAgencesPage() {
  return <ComptesListView type="agence" />;
}